import { useMutation } from '@tanstack/react-query';
import { documentService, DeleteDocumentPayload } from '@services/document';
import { toast } from 'react-toastify';
import { useQueryClient } from '@tanstack/react-query';
import { getErrorMessage } from '@utils/errorMessage';
import { useTranslation } from '@hooks/useTranslation';

export const useDeleteDocument = () => {
  const tActionMessages = useTranslation('actionMessages');
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['documents', 'delete'],
    mutationFn: async (payload: DeleteDocumentPayload) => {
      return await documentService.deleteDocument(payload);
    },
    onSuccess: (data) => {
      if (data?.affected > 0) {
        toast.success(tActionMessages.documentDeletedSuccessfully);

        // Invalidate relevant queries to refresh the UI
        queryClient.invalidateQueries({ queryKey: ['documents'] });
        queryClient.invalidateQueries({ queryKey: ['projects'] });
      } else {
        toast.error(tActionMessages.failedToDeleteDocument);
      }
    },
    onError: (error: any) => {
      console.error('Document deletion error:', error);
      toast.error(
        getErrorMessage(error, 'Failed to delete document. Please try again.'),
      );
    },
  });
};

export default useDeleteDocument;
